export interface IActivityFeedUserData {
  name: string;

  username: string;

  image?: string;

  merchantGroupId: string;

  jobTitleId?: number;

  merchantId?: number;

  costCentreId?: number;

  departmentId?: number;

  [x: string]: unknown;
}
